import React from 'react';
import { SpinnerLoading } from '../../common/icons';

const LoadingScreen = (props) => {

    return (
    <div className='loader'></div>
    );
}

export default LoadingScreen;
